import { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import { list2 } from '../../../services/Api'
import { DispatchContext } from "../../../reducers";
import { useWindow } from '../../../hooks'
import moment from 'moment';
import { Gauge } from '../../../components';
import { Grid } from '@mui/material'
import { GeneralChart } from '../../../components';
import { GeneralGrid } from '../../../components';
import { StockChart } from '../../../components';
import { oscillators } from '../../../config'



export const MarketWrap = ({ type: initType }) => {
    const { type: path } = useParams()
    const type = initType || path
    const size = useWindow()
    const dispatch = useContext(DispatchContext)
    const [momentum, setMomentum] = useState()
    const [overall, setOverall] = useState()
    const [vol, setVol] = useState()
    const [commentary, setCommentary] = useState()
    const [flipData, setFlipData] = useState()
    const [table, setTableData] = useState()
    const [spec, setSpec] = useState()
    const [crowd, setCrowd] = useState()
    const [maxPos, setMaxPos] = useState()
    const [brentPrices, setBrentPrices] = useState()
    const [gasoilPrices, setGasoilPrices] = useState()
    const [oiData, setOiData] = useState([])
    const [ctaComment, setCtaCommentary]= useState()
    const [date, setDate] = useState()

    useEffect(() => {
        async function fetch () {
            if (!type) return
            dispatch({ type: 'spin on' })
            const [technicalScoreDataset, marketBulletsDataset, ctaDataset, oiDataset, brentOhlc, gasoilOhlc] = await Promise.all([
                list2('quant_view/technical_score',null , {product: type}),
                list2('quant_view/market_bullets', null , {product: type}),
                list2('quant_view/cta_data',null , {product: type}),
                list2('quant_view/oi_data', null , {product: type}),
                list2('priceOhlc', 'price_interday01'),
                list2('priceOhlc', 'price_interday06')
            ])

            const {commentary, date} = marketBulletsDataset
            const overallRating = technicalScoreDataset['Overall Rating']
            const momentumRating = technicalScoreDataset['Momentum Rating']
            const volatilityRating = technicalScoreDataset['Volatility Rating']

            const speculativeData = ctaDataset['speculative']
            const crowdedness = ctaDataset['crowdedness']
            const maximumPos = ctaDataset['maxPosition']
            const flip = ctaDataset['flip'].filter(item => item['Total Flip Lots'] != 0)
            const tableData = ctaDataset['table']
            const ctaCom = ctaDataset['commentary']['commentary']
          
        
            dispatch({ type: 'spin off' })
            setOverall(overallRating)
            setMomentum(momentumRating)
            setVol(volatilityRating)
            setCommentary(commentary)
            setSpec(speculativeData)
            setCrowd(crowdedness)
            setMaxPos(maximumPos)
            setOiData(oiDataset)
            setFlipData(flip)
            setDate(date)
            setTableData(tableData)
            setCtaCommentary(ctaCom)
            setBrentPrices(brentOhlc)
            setGasoilPrices(gasoilOhlc)
          
        }
        fetch()
    }, [type])


    const commentaryFormatting = (comStr) => {

        let commentaryStrSplit = comStr.split('\r\n')

        let commentaryTitle = commentaryStrSplit[0]

        let commentary = commentaryStrSplit.slice(1).filter(item => item !== '')

        let formatted = (<div>
                <label className='f-03 underline'>{commentaryTitle}</label> 
                {
                    commentary.map(i => {
                        return (
                    <div className='mb-2'>
                       
                            <label className='f-02 bold'>{i.split(':')[0]}</label>:
                            <label className='f-02 ml-2'>{i.split(':')[1]}</label>
                        </div>)
                        }
                        
                    )
                }
             </div>)

             return formatted

    }

    return (
        <div className="column-center w-full mb-6">
        <Grid container className='w-full row-around-start'>
            <div className="column-center">
            <div className='f-12 bold m-5'>Market News Summary ({moment(date).format('YYYY-MM-DD')})</div>
            {
            commentary && <div className='column-start m-5'>
                                {commentaryFormatting(commentary)}
                               
                            </div>
            
            }
            </div>
            <div className="column-center">
            <div className='f-12 bold m-5'> ICE {type == 'Crude' ? 'Brent' : 'LSGO'} Market Pulse </div>
            <Grid container className='row-around w-full'>
            <Gauge 
                    subtitle={'Momentum Strength'}
                    ticks={[{value: 12 }, {value: 37}, {value: 62}, {value: 87}]}
                    value={momentum}
                    customLabels={{
                        12: 'Weak', 37: 'Strong', 62: 'Very Strong', 87: 'Extremely Strong'
                    }}
                    subArcs={[
                        {
                          limit: 25,
                          color: '#5dade2',
                         // showTick: true
                        },
                        {
                          limit: 50,
                          color: '#2e86c1',
                          //showTick: true
                        },
                        {
                          limit: 75,
                          color: '#21618c',
                          //showTick: true
                        },
                        {
                          limit: 100,
                          color: '#154360',
                          //showTick: true
                        },
                      ]}
                />
                <Gauge 
                    max={1}
                    min={-1}
                    subtitle={'Market Direction'}
                    ticks={[{value: -0.8}, {value: -0.4}, {value: 0}, {value: 0.4},  {value: 0.8}]}
                    value={overall}
                    customLabels={{
                        "-0.8": 'Strong Bearish',  "-0.4": 'Bearish', 0: 'Neutral', 0.4: 'Bullish', 0.8: 'Strong Bullish'
                    }}
                    subArcs={[
                        {
                          limit: -0.6,
                          color: '#FF7F7F',
                          //showTick: true
                        },
                        {
                          limit: -0.2,
                          color: '#FF9966',
                          //showTick: true
                        },
                        {
                          limit: 0.2,
                          color: '#FFCC66',
                          //showTick: true
                        },
                        {
                          limit: 0.6,
                          color: '#66CC66',
                          //showTick: true
                        },
                        {
                            limit: 1,
                            color: '#66FF66',
                            //showTick: true
                          },
                      ]}
                />
                <Gauge 
                    subtitle={'Volatility Rating'}
                    ticks={[{value: 10}, {value: 30}, {value: 50}, {value: 70},  {value: 90}]}
                    value={vol}
                    customLabels={{
                        10: 'Very Low', 30: 'Low', 50: 'Average', 70: 'High', 90: 'Very High'
                    }}
                    subArcs={[
                        {
                            limit: 20,
                            color: '#FF7F7F',
                            //showTick: true
                          },
                          {
                            limit: 40,
                            color: '#FF9966',
                            //showTick: true
                          },
                          {
                            limit: 60,
                            color: '#FFCC66',
                            //showTick: true
                          },
                          {
                            limit: 80,
                            color: '#66CC66',
                            //showTick: true
                          },
                          {
                              limit: 100,
                              color: '#66FF66',
                              //showTick: true
                            },
                      ]}
                />

            </Grid>
            <div id="for-ohlc" className="row-center">
                {
                    type === 'Crude' ? brentPrices && <StockChart data={brentPrices} conditions={{ instrument: { name: 'ICE Brent Crude' }, overlay: 'bb', oscillator: oscillators[1] }} /> : gasoilPrices && <StockChart data={gasoilPrices} conditions={{ instrument: { name: 'ICE LSGO' }, overlay: 'bb', oscillator: oscillators[1] }} />
                }
            </div>
            </div>
            

          
        </Grid>
        <Grid container className='row-center w-full my-2'>
            
            { oiData && <Grid item md={6}> <GeneralChart param={{
                isSingle: false,
                title: {text: 'Latest OI By Month'},
                subtitle: {
                    text: `Data Source: ICE Exchange`, align: 'right'
                },
                yAxis: {
                    title: { text: 'Open Interest'}
                },
                xAxis: {
                    categories: oiData.map(({month}) => month)
                },
                series: {
                    name: 'Latest OI',
                    type: 'line',
                    data: oiData.map(({absoluteOi}) => absoluteOi)
                }
            }}/> </Grid> }

{ oiData && <Grid item md={6}> <GeneralChart param={{
                isSingle: false,
                chart: {
                    type: 'bar'
                },
                title: {text: 'OI Difference By Month'},
                subtitle: {
                    text: `Data Source: ICE Exchange`, align: 'right'
                },
                yAxis: {
                    title: { text: 'Open Interest Difference'}
                },
                xAxis: {
                    categories: oiData.map(({month}) => month)
                },
                series: [
                    {
                        name: 'OI Surplus',
                        color: '#00b050',
                        data: oiData.map(({oiDiff}) => {return oiDiff > 0 ? oiDiff : null})
                    },
                    {
                        name: 'OI Deficit',
                        color: '#e5633f',
                        data: oiData.map(({oiDiff}) => {return oiDiff < 0 ? oiDiff : null})
                    },
                ], 
            }}/> </Grid> }



        </Grid>
        <div className='f-12 bold m-5'>CTA Positioning ({moment(date).format('YYYY-MM-DD')})</div>
        <Grid container className='row-center w-full my-2'>

        { spec && <Grid item md={6}> <GeneralChart param={{
                isSingle: false,
                title: {text: 'Daily Speculative Length Breakdown, K Lots'},
                subtitle: {
                    text: `Data Source: Energy Aspects`, align: 'right'
                },
                yAxis: {
                    title: { text: 'Lots'}
                },
                xAxis: {
                    type: 'datetime',  // Use datetime for proper time-based intervals
                    tickInterval: 30 * 24 * 3600 * 1000, // Approx. 1 month in milliseconds
                    labels: {
                        format: '{value:%b %Y}' // Formats as 'Jan 2024', 'Feb 2024', etc.
                    }
                   
                },
                series: [{
                    name: 'Discretionary',
                    type: 'line',
                    data: spec.map(({ date, Discretionary }) => [new Date(date).getTime(), parseFloat(Discretionary)])
                },
                {
                    name: 'CTA',
                    type: 'line',
                    data: spec.map(({ date, CTA }) => [new Date(date).getTime(), parseFloat(CTA)])
                },
                {
                    name: 'Risk Parity',
                    type: 'line',
                    data: spec.map((item) => [new Date(item.date).getTime(), parseFloat(item['Risk Parity'])])
                },
                {
                    name: 'ETF',
                    type: 'line',
                    data: spec.map(({ date, ETF }) => [new Date(date).getTime(), parseFloat(ETF)])
                },
            
            ]
            }}/> </Grid> }

{ crowd && <Grid item md={6}> <GeneralChart param={{
                isSingle: false,
                title: {text: 'Position Crowdedness, Percentile Rank (%)'},
                subtitle: {
                    text: `Data Source: Energy Aspects`, align: 'right'
                },
                yAxis: {
                    title: { text: '%'}
                },
                xAxis: {
                    type: 'datetime',  // Use datetime for proper time-based intervals
                    tickInterval: 30 * 24 * 3600 * 1000, // Approx. 1 month in milliseconds
                    labels: {
                        format: '{value:%b %Y}' // Formats as 'Jan 2024', 'Feb 2024', etc.
                    }
                   
                },
                series: [{
                    name: 'Crowdedness (%)',
                    type: 'line',
                    data: crowd.map(({date, value}) => [new Date(date).getTime(), parseFloat(value)*100])

                }]
            }}/> </Grid> }

{ maxPos && <Grid item md={6}> <GeneralChart param={{
                isSingle: false,
                title: {text: 'Percentage of Maximum CTA Position (%)'},
                subtitle: {
                    text: `Data Source: Energy Aspects`, align: 'right'
                },
                yAxis: {
                    title: { text: '%'}
                },
                xAxis: {
                    type: 'datetime',  // Use datetime for proper time-based intervals
                    tickInterval: 30 * 24 * 3600 * 1000, // Approx. 1 month in milliseconds
                    labels: {
                        format: '{value:%b %Y}' // Formats as 'Jan 2024', 'Feb 2024', etc.
                    }
                   
                },
                series: [{
                    name: 'Maximum CTA Positions (%)',
                    type: 'line',
                    data: maxPos.map(({date, value}) => [new Date(date).getTime(), parseFloat(value)*100])

                }]
            }}/> </Grid> }

{ flipData && <Grid item md={6}> <GeneralChart param={{
                isSingle: false,
                chart: {
                    type: 'bar'
                },
                title: {text: `${type} Price Level of CTA Flows, $/bbl`},
                subtitle: {
                    text: `Data Source: Energy Aspects`, align: 'right'
                },
                yAxis: {
                    title: { text: 'Lots'}
                },
                xAxis: {
                    categories: flipData.map((item) => parseFloat(item['Flip Basket'])),
                  
                },
                series: [
                    {
                        name: 'Long',
                        color: '#00b050',
                        data: flipData.map((item) => {return parseFloat(item['Total Flip Lots']) > 0 ? parseFloat(item['Total Flip Lots']) : null})
                    },
                    {
                        name: 'Short',
                        color: '#e5633f',
                        data: flipData.map((item) => {return parseFloat(item['Total Flip Lots']) < 0 ? parseFloat(item['Total Flip Lots']) : null})
                    },
                ], 
            }}/> </Grid> }

            {
                ctaComment && <Grid item md={6}>
                    <div className='f-05 m-5'>{ctaComment}</div>
                </Grid>
            }


{ table && <Grid item md={6} className="w-95p"> <GeneralGrid param={{
    colDef: Object.keys(table[0]).map(name => ({field: name})),
    data: table, maxHeight: 650
}}/> </Grid> }

        </Grid>
        </div>
    )
}